import styled from 'styled-components';

export const FeaturesViewportWrapper = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  top: 0;
  height: ${props => `calc(100% - ${props.tabHeight}px`});
`;
